import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core'
import { WidgetPropertyService } from '@gspwidget/widget-core'
import { PropertyOption, PropertyTypes } from '@gspwidget/widget-devkit'
import { TranslateService } from '@ngx-translate/core'
import { PropertyChangeEvent, PropsAndValues } from '../types'

export interface CEGroupValuePayload {
  group: CEGroup
  allValues: object
}
export interface CEGroup {
  name: string
  children: PropertyOption[]
}
/**
 * CE åç»ä»¶å¼ç¨å³ç³»ï¼
 * ce2        ->      ce-item -> ce2 -> ...
 *     -> ce-array ->
 */
@Component({
  selector: 'config-editor2',
  templateUrl: './config-editor2.component.html',
  styleUrls: ['./config-editor2.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
  // providers: [ CeService ]
})
export class ConfigEditor2Component implements OnInit {

  @Output() onChange = new EventEmitter<PropertyChangeEvent>()
  @Output() copyGroupValues = new EventEmitter<CEGroupValuePayload>()
  @Output() pasteGroupValues = new EventEmitter<CEGroupValuePayload>()

  propCategories: CEGroup[]
  props: PropertyOption[]
  propValues: object
  /** å¿å¡« */
  @Input() set propsAndValues (propsNValues: PropsAndValues) {
    if (!propsNValues) return
    const { props, propValues } = propsNValues
    this.props = processProps(props)
    this.propValues = propValues

    /* æ category åç±»ç»ç» props */
    // if (!this.showcategory) return
    this.propCategories = []
    const otherCategory = { name: 'other', children: [] }
    if (props) props.forEach(prop => {
      // æ²¡å category çæ¾å° âå¶ä»â
      if (!prop.category) {
        otherCategory.children.push(prop)
      } else {
        // åäº category çæ¾å°å¯¹åºçéé¢
        let category = this.propCategories.find(c => c.name === prop.category)
        if (!category) {
          category = { name: prop.category, children: [] }
          this.propCategories.push(category)
        }
        category.children.push(prop)
      }
    })
    // âå¶ä»â ææå
    if (otherCategory.children.length > 0) this.propCategories.push(otherCategory)
  }
  @Input() showCategory = true
  @Input() extra: any = {}

  constructor (
    public cd: ChangeDetectorRef
  ) { }

  // TODO: èèææçæ¹åé½éè¿ service ä¼ éå°è¿éï¼
  handleValueChange (prop: PropertyOption, newValue: any) {
    this._changeValue(prop, newValue)
  }
  private _changeValue (prop: PropertyOption, newValue: any) {
    // console.log('åè¾½', newValue)
    // this.ceSvc.onChange(prop.name, newValue)
    this.propValues[prop.name] = newValue
    this.onChange.emit({
      propName: prop.name,
      value: newValue
    })
    if (prop.afterChange) prop.afterChange(this.propValues, newValue, this.cd)
  }

  ngOnInit () {
  }

  handleCopyCEGroupPVs (e, group: CEGroup) {
    e.preventDefault()
    e.stopPropagation()
    this.copyGroupValues.emit({
      group,
      allValues: this.propValues
    })
  }
  handlePasteCEGroupPVs (e, group: CEGroup) {
    e.preventDefault()
    e.stopPropagation()
    this.pasteGroupValues.emit({
      group,
      allValues: this.propValues
    })
  }

}

/**
 * å¤çåå§ propsï¼è¿åå¯ç¨ç propsã
 * éåä¼ å¥ç propsï¼è¥æ dynamic ç±»ååæ¨å¥å¶æ³¨å propï¼è¥æ²¡æåä¿æå propã
 */
function processProps (rawProps: PropertyOption[]): PropertyOption[] {
  const props: PropertyOption[] = []
  rawProps.forEach((prop, i) => {
    if (prop.type === PropertyTypes.Dynamic) {
      let registeredProps
      if (prop.dynamicOption.name) {
        registeredProps = WidgetPropertyService.GetRegisteredProperties(prop.dynamicOption.name)
      } else if (prop.dynamicOption.getOptions) {
        registeredProps = prop.dynamicOption.getOptions()
      }
      if (registeredProps) props.push(...registeredProps)
    } else {
      props.push(prop)
    }
  })
  return props
}
